import React from "react";
import ReactExport from "react-export-excel";
import {Button} from "reactstrap";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const DownloadReport = ({dataSet}) => {
  return (
    <ExcelFile element={<Button color="info">Exportar</Button>} filename={`Reporte-${new Date().getTime()}`}>
      <ExcelSheet data={dataSet} name="Reporte">
				<ExcelColumn label="Numero de Guia" value="consecutive"/>
				<ExcelColumn label="Documento externo" value="tracking_code"/>
				<ExcelColumn label="Fecha" value="pickup_date"/>
				<ExcelColumn label="Fecha de entrega" value="delivery_date"/>
				<ExcelColumn label="Facturar a" value="customer_to_bill_name"/>
				<ExcelColumn label="Remitente" value="customer"/>
				<ExcelColumn label="Destinatario" value="receiver_name"/>
				<ExcelColumn label="Sucursal" value="pickup_branch"/>
				<ExcelColumn label="Ciudad de recogida" value="pickup_city"/>
				<ExcelColumn label="Ciudad de entrega" value="delivery_city"/>
				<ExcelColumn label="Tipo de Pago" value="customer_payment_type"/>
				<ExcelColumn label="Estado" value="status"/>
				<ExcelColumn label="Grupo" value="group"/>
				<ExcelColumn label="Subgrupo" value="subgroup"/>
				<ExcelColumn label="Vehiculo" value="pickup_vehicle"/>
				<ExcelColumn label="Total Unidades" value="total_units"/>
				<ExcelColumn label="Peso" value="weight"/>
				<ExcelColumn label="Flete Fijo" value="freight_value"/>
				<ExcelColumn label="Flete Variable" value="variable_freight"/>
				<ExcelColumn label="Otros Valores" value="other_value"/>
				<ExcelColumn label="Descuento" value="discount"/>
				<ExcelColumn label="Total" value="total_value"/>
      </ExcelSheet>
    </ExcelFile>
  );
};

export default DownloadReport;
